<template>
	<div class="base">
		<van-row>
			<van-col span="12">
				<div style=" display: flex; justify-content: flex-start; align-items: center; padding-left: 15px;">
					<img 
						style="height: 36px; width: 166px; object-fit: contain;" 
						src="@/assets/download/GooglePlaybestapp.png"
					/>
				</div>
			</van-col>
			<van-col span="12">
				<div style="height: 100%; display: flex; justify-content: flex-end; align-items: center;padding-right: 5px;">
					<img 
						style="height: 36px; width: 114px; object-fit: contain;" 
						src="@/assets/download/GooglePlaybestapp-right.png"
					/>
				</div>
			</van-col>
		</van-row>
	</div>
</template>
<script setup lang="ts">
</script>

<style scoped>
	.base {
		align-items: center;
		/* justify-content: flex-start; */
		/* position: fixed; */
		width: 100%;
		z-index: 20000;
		padding: 6px 0px 6px 0px;
		background-color: #fff;
        position: fixed;
        top: 0;
	}

	
</style>